import React, { useState } from 'react'
import cx from 'classnames'

import { PageLink } from 'src/components/link'

export const Nav = ({ path }) => {
  const [open, setOpen] = useState(false)
  const returnPage = () => {
    if (path === 'index') {
      return 'Full Catalog +'
    }
    if (path !== 'index' && path !== undefined) {
      if (/products/.test(path)) {
        return null
      }
      if (/about/.test(path)) {
        return null
      }
      if (/collection/.test(path)) {
        return path.replace('/collection/', '') + ' +'
      }
    }
  }
  return (
    <div className='header__nav'>
      <div className='px1 outer ac' onClick={() => setOpen(!open)}>
        <span className={cx('s1 underline caps', open && 'none')}>
          {returnPage()}
        </span>
        <div className={cx('header__nav-items', open && 'is-open')}>
          <PageLink className='caps block s1 cb' to='/'>All</PageLink><span className='s1 caps cb'>,&nbsp;</span>
          <PageLink className='caps block s1 cb' to='/collection/art'>Art</PageLink><span className='s1 caps cb'>,&nbsp;</span>
          <PageLink className='caps block s1 cb' to='/collection/clothing'>clothing</PageLink><span className='s1 caps cb'>,&nbsp;</span>
          <PageLink className='caps block s1 cb' to='/collection/accessories'>Accessories</PageLink><span className='s1 caps cb'>,&nbsp;</span>
          <PageLink className='caps block s1 cb' to='/collection/publications'>Publications</PageLink>
        </div>
      </div>
    </div>
  )
}